/**
 * Mirrors card_service's `BASIC_DIGITAL_V2_PRODUCT_ID` (`basic-digital-v2.data.ts`): the free
 * product is a seeded `stationeryProduct` row with this fixed id, and card_service's free-order
 * entitlement gate identifies it the same way.
 */
export const BASIC_DIGITAL_V2_PRODUCT_ID = 'JOYBASICDIGITALV2';

type BasicDigitalV2Candidate = Readonly<{ id: string; productType: string }>;

/** Whether `product` is the free Basic Digital V2 product. Nullish (e.g. a draft with no product) is not. */
export const isBasicDigitalV2 = (product: BasicDigitalV2Candidate | null | undefined): boolean => product?.id === BASIC_DIGITAL_V2_PRODUCT_ID;
